import React, { useContext, useEffect, useState } from 'react';
import {
  ContentType,
  ContentAudience,
  WorkflowState,
} from '@amzn/awscat-pattern-library-service-model';
import { contentAudienceBadgeDisplayNames } from '../../utils/DisplayNames';
import HomePageCtx from './HomePageCtx';
import { Box } from '@amzn/awsui-components-core';

export enum FilterType {
  ContentType = 'contentType',
  AudienceType = 'publicationState',
}

interface Props {
  filterType: FilterType;
  filterText: ContentType | ContentAudience | WorkflowState;
  readOnly?: boolean;
  workflowStateToAudienceMap?: Map<WorkflowState, string>;
  displayLabel?: string;
}

const FilterBadge = (props: Props) => {
  const { setFilterOptions, filterOptions } = useContext(HomePageCtx);
  const [selected, setSelected] = useState(false);
  const { filterType, filterText, readOnly, workflowStateToAudienceMap, displayLabel } = props;

  const getAudienceFilterKey = () =>
    displayLabel ??
    // @ts-expect-error TS2532 - strict migration
    contentAudienceBadgeDisplayNames.get(filterText as ContentAudience).replace(/\s/gi, '');

  useEffect(() => {
    if (readOnly) {
      return;
    }
    const filterSection = filterOptions?.[filterType];
    if (filterSection && Object.keys(filterSection.options).length) {
      let filterValue;
      switch (filterType) {
        case FilterType.AudienceType:
          filterValue = getAudienceFilterKey();
          break;
        default:
          filterValue = filterText;
      }

      if (selected) {
        if (filterSection.options[filterValue]) {
          if (
            // @ts-expect-error TS2532 - strict migration
            filterSection.options[filterValue].selected !== undefined &&
            // @ts-expect-error TS2532 - strict migration
            selected !== filterSection.options[filterValue].selected
          ) {
            // @ts-expect-error TS2532 - strict migration
            setSelected(filterSection.options[filterValue].selected);
          }
        } else {
          const emptyFilterOption = {
            count: 0,
            label: filterValue,
            selected: false,
            value: filterValue,
          };
          filterSection.options[filterValue] = emptyFilterOption;
          setFilterOptions({ ...filterOptions });
        }
      }
    }
  }, [filterOptions]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleBadgeClick = () => {
    if (readOnly) {
      return;
    }
    const selectedOption = !selected;
    const filterSection = filterOptions[filterType];
    switch (filterType) {
      case FilterType.ContentType:
        // @ts-expect-error TS18048 - strict migration
        if (filterSection.options[filterText]) {
          // @ts-expect-error TS18048 - strict migration
          filterSection.options[filterText].selected = selectedOption;
        } else {
          const emptyFilterOption = {
            count: 0,
            label: filterText,
            selected: selectedOption,
            value: filterText,
          };
          // @ts-expect-error TS18048 - strict migration
          filterSection.options[filterText] = emptyFilterOption;
        }
        setFilterOptions({ ...filterOptions });
        break;
      case FilterType.AudienceType:
        const filterValue = getAudienceFilterKey();
        // @ts-expect-error TS18048 - strict migration
        if (filterSection.options[filterValue]) {
          // @ts-expect-error TS18048 - strict migration
          filterSection.options[filterValue].selected = selectedOption;
        } else {
          const emptyFilterOption = {
            count: 0,
            label: filterValue,
            selected: selectedOption,
            value: filterValue,
          };
          // @ts-expect-error TS18048 - strict migration
          filterSection.options[filterValue] = emptyFilterOption;
        }
        setFilterOptions({ ...filterOptions });
        break;
    }
    setSelected(selectedOption);
  };

  const renderBadgeContent = () => {
    if (filterType === FilterType.ContentType) {
      return (
        <>
          <div className={`square ${filterText.toLowerCase()}-color`} />
          {filterText}
        </>
      );
    }
    if (readOnly && workflowStateToAudienceMap) {
      return (
        <Box color="text-body-secondary" fontSize="body-s">
          {workflowStateToAudienceMap.get(filterText as WorkflowState)}
        </Box>
      );
    }
    return (
      <>{displayLabel ?? contentAudienceBadgeDisplayNames.get(filterText as ContentAudience)}</>
    );
  };

  const className = selected ? 'filter-badge-selected' : 'filter-badge-not-selected';
  return (
    <button
      className={`filter-badge${readOnly ? '-read-only' : ''} ${className}`}
      onClick={handleBadgeClick}
    >
      {renderBadgeContent()}
    </button>
  );
};

export default FilterBadge;
